import React, { useState, useEffect, } from 'react'
import HtmlParser from 'react-html-parser';
import { useParams } from 'react-router';
import { Link } from 'react-router-dom';

import $ from 'jquery';

import moment from 'moment-timezone';
import 'react-tempusdominus-bootstrap';

import Swal from 'sweetalert2';

import axios from 'axios';

import Menu from '../main/Menu';
import PurchaseConceptAdd from './PurchaseConceptAdd';
import PurchaseConceptEdit from './PurchaseConceptEdit';
import PurchaseFiles from './PurchaseFiles';

import { purchaseTaxesGetAsync, purchaseFormDataValidateAsync, purchaseExpenseConceptsGetAsync, purchaseStatusGet } from '../../controllers/purchases/purchases';
import {
    checkIfUserIsMaster, dataTableLanguaje, responseGet, globalSettings, numberSet, styles, separatorsNumbersSet, sendMessageCloseCurrentWindowAsync,
    buttonProcessGet, dateTimeFormatGlobalSet, awaitDelay, processEvaluateGet, languageObjGet, isUndNullEmp, LoadingSection,
} from '../../helpers/settings';
import useAuth from '../../controllers/users/useAuth';
import BuildingHeader from '../buildings/BuildingHeader';
import { purchaseDetailsCalculate } from '../../controllers/expenses/purchases';
import { GlobalFormats } from '../../classes/main/globalFormats';
import { buildingModelGet } from '../../models/buildings/building';
import { purchaseDetailModelGet, purchaseModelGet } from '../../models/expenses/purchase';
import { conceptModelGet } from '../../models/expenses/concept';
import { taxModelGet } from '../../models/taxes/tax';
import { supplierModelGet } from '../../models/expenses/suppliers';

const currentMethod = 'PurchaseEdit';

export default function PurchaseEdit({
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region others
    let result;
    let dataObj = {};
    let headerObj = {};
    const auth = useAuth();
    const neutralValue = 0.00;
    const { id, } = useParams();
    //const history = useHistory();
    const userRole = checkIfUserIsMaster({ email: auth?.user?.email || '', languageId: languageObj?.id, subMethod: currentMethod, })?.result;
    const [showView, setShowView] = useState(false);
    const [processType, setProcessType] = useState(0);
    const [showLoading, setShowLoading] = useState({ building: true, purchase: true, purchaseDetail: true, });
    //const [showData, setShowData] = useState(false);
    //#endregion others

    //#region building
    const [building, setBuilding] = useState(buildingModelGet({}));
    //#endregion building

    //#region purchase
    const purchaseDateId = 'purchaseDate';
    let purchaseTwo = purchaseModelGet({});
    const [dateError, setDateError] = useState('');
    const [numberError, setNumberError] = useState('');
    const [supplierError, setSupplierError] = useState('');
    const [purchase, setPurchase] = useState(purchaseModelGet({}));
    const [purchaseNumberError, setPurchaseNumberError] = useState('');
    const [purchaseDescriptionError, setPurchaseDescriptionError] = useState('');
    const [purchaseControlNumberError, setPurchaseControlNumberError] = useState('');
    //#endregion purchase

    //#region purchase details
    const dtPurchaseDetailsId = 'dtPurchaseDetails';
    const [dtPurchaseDetailsRowIndex, setDtPurchaseDetailsRowIndex] = useState(0);
    const [purchaseDetailShowModal, setPurchaseDetailShowModal] = useState(false);
    const [purchaseDetails, setPurchaseDetails] = useState([purchaseDetailModelGet({})]);
    const [purchaseDetailsBeforeEdited, setPurchaseDetailsBeforeEdited] = useState([purchaseDetailModelGet({})]);
    //#endregion purchase details

    //#region suppliers
    const [suppliers, setSuppliers] = useState([]);
    //#endregion suppliers

    //#region purchase detail
    const [purchaseDetail, setPurchaseDetail] = useState(purchaseDetailModelGet({}));
    const [purchaseDetailEditShowModal, setPurchaseDetailEditShowModal] = useState(false);
    const [purchaseDetailEditDelete, setPurchaseDetailEditDelete] = useState({ expenseConceptId: '', description: '', rowIndex: 0, processType: 0, subMethod: '', });
    //#endregion purchase detail

    //#region concepts
    const [concepts, setConcepts] = useState([conceptModelGet({})]);
    //#endregion concepts

    //#region taxes
    const [taxes, setTaxes] = useState([taxModelGet({})]);
    //#endregion taxes

    //#region attachment
    const [filesShowModal, setFilesShowModal] = useState(false);
    const [btnAttachmentDisabled, setBtnAttachmentDisabled] = useState(true);
    //#endregion attachment

    //#region others
    const controls = {
        buttons: {
            save: {
                id: 'btnSave',
                className: 'btn btn-outline-warning mx-1',
            },
            attachment: {
                id: 'btnAttachment',
                className: 'btn btn-outline-info',
            },
            back: {
                id: 'btnBack',
                className: 'btn btn-outline-success mx-1',
            },
        },
        checkBox: {
            isNational: {
                attributes: {
                },
                id: 'chkIsNational',
                className: 'icheck-primary d-inline',
            },
        },
        dataTables: {
            purchaseDetails: {
                buttons: {
                    detailAdd: {
                        className: 'btn btn-sm btn-outline-info mx-1 float-right',
                        id: 'btnDtPurchaseDetailsIdDetailAdd',
                    },
                    detailEdit: {
                        className: 'btn btn-sm btn-outline-warning float-right',
                        id: 'btnDtPurchaseDetailsIdDetailEdit',
                    },
                    detailDelete: {
                        className: 'btn btn-sm btn-outline-danger mx-1 float-right',
                        id: 'btnDtPurchaseDetailsIdDetailDelete',
                    },
                },
                icons: {
                    detailAdd: {
                        id: 'iconDtPurchaseDetailsIdDetailAdd',
                        className: globalSettings?.icons?.list,
                    },
                    detailEdit: {
                        id: 'iconDtPurchaseDetailsIdDetailEdit',
                        className: globalSettings?.icons?.edit,
                    },
                    detailDelete: {
                        id: 'iconDtPurchaseDetailsIdDetailDelete',
                        className: globalSettings?.icons?.trash,
                    },
                },
                inputs: {
                    search: {
                        id: `${dtPurchaseDetailsId}_filter input`,
                        className: '',
                    },
                },
                selects: {
                    entries: {
                        id: `${dtPurchaseDetailsId}_length select`,
                        className: '',
                    },
                },
                spinners: {
                    detailAdd: {
                        id: 'spDtPurchaseDetailsIdDetailAdd',
                        className: '',
                    },
                    detailEdit: {
                        id: 'spDtPurchaseDetailsIdDetailEdit',
                        className: '',
                    },
                    detailDelete: {
                        id: 'spDtPurchaseDetailsIdDetailDelete',
                        className: '',
                    },
                },
            },
        },
        icons: {
            save: {
                id: 'icoSave',
                className: globalSettings?.icons?.save,
            },
            attachment: {
                id: 'icoAttachment',
                className: globalSettings?.icons?.paperClip,
            },
            back: {
                id: 'icoBack',
                className: globalSettings?.icons?.arrowCircleLeft,
            },
        },
        inputs: {
            purchaseNumber: {
                id: 'inputPurchaseNumber',
                className: 'form-control',
            },
            date: {
                id: 'inputDate',
                className: 'form-control text-black bg-transparent datetimepicker-input',
            },
            purchaseNumberSupplier: {
                id: 'inputPurchaseNumberSupplier',
                className: 'form-control',
            },
            purchaseControlNumberSupplier: {
                id: 'inputPurchaseControlNumberSupplier',
                className: 'form-control',
            },
            remark: {
                id: 'inputRemark',
                className: 'form-control',
            },
        },
        selects: {
            suppliers: {
                id: 'selSuppliers',
                className: 'form-select',
            },
        },
        spinners: {
            save: {
                id: 'spSave',
                className: '',
            },
            attachment: {
                id: 'spAttachment',
                className: '',
            },
            back: {
                id: 'spBack',
                className: '',
            },
        },
        urls: {
            // forgotYourPassword: {
            //     id: 'urlForgotYourPassword',
            //     className: 'btn-link',
            // },
            // reCaptchaPrivaciConditions: {
            //     id: 'urlReCaptchaPrivaciConditions',
            //     className: '',
            // },
            // userRegister: {
            //     id: 'urlRequestAccount',
            //     className: '',
            // },
            // registerStatus: {
            //     id: 'urlStatusRegister',
            //     className: '',
            // },
        },
    };
    //#endregion others

    //#region methods (purchase)
    const purchaseEditPostAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'purchaseEditPostAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            //#region variables
            let purchaseAfter = purchaseModelGet({});
            let purchaseDetailsAfter = [purchaseDetailModelGet({})];
            //#endregion variables

            //#region errors default set
            response = await errorsDefaultSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion errors default set

            //#region purchase data set
            response = await purchaseDataSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion purchase data set

            //#region form data validate
            response = await formDataValidateAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion form data validate

            //#region update / add purchase / purchase details
            controlsStatusSet({ processType: 1, subMethod: currentMethod, });

            purchase[globalSettings?.collections?.properties?.details] = purchaseDetails;
            purchase[globalSettings?.collections?.properties?.detailsBeforeEdited] = purchaseDetailsBeforeEdited

            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                },
            };

            dataObj = {
                purchase: purchase,
                languageId: languageObj?.id,
                languageCode: languageObj?.code,
                url: `${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlPurchases}/${purchase?.id}`,
            };

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj,
            );

            response = result?.data;

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            purchaseAfter = response?.result?.purchase || {};
            purchaseDetailsAfter = response?.result?.details || [];

            setPurchase(purchaseAfter)
            setPurchaseDetailsBeforeEdited(purchaseDetailsAfter);
            //#endregion update / add purchase / purchase details

            controlsStatusSet({ processType: 0, subMethod: currentMethod, });

            response.msgText = `${globalSettings?.messages?.processesCompletedSuccessfully?.[languageObj?.id]}<br/>`;
            response.msgText += `${globalSettings?.labels?.purchase?.[languageObj?.id]}: <b>${purchaseAfter?.number}</b>`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: 0,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const purchaseDataSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'purchaseDataSetAsync';
        let response = responseGet();
        try {
            //#region variables
            const dateTimeObj = {
                date: $(`#${purchaseDateId}`)?.datetimepicker('date')?._d,
            };
            //#endregion variables

            //#region methods
            purchase.date = !isUndNullEmp({ data: dateTimeObj?.date, subMethod: currentMethod, })?.result ? dateTimeObj?.date : purchase?.date;
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }
    //#endregion methods (purchase)

    //#region methods (purchase details)
    const dataTablePurchaseDetailsSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'dataTablePurchaseDetailsSetAsync';
        let response = responseGet();
        try {
            $(`#${dtPurchaseDetailsId}`)?.DataTable({
                //buttons: ['excel', 'pdf', 'print', 'colvis',],
                autoWidth: false,
                columns: [
                    { title: globalSettings?.labels?.concept?.[languageObj?.id], width: '40%', orderable: false, },
                    { title: globalSettings?.labels?.quantity?.[languageObj?.id], className: 'text-right', orderable: false, width: '10%', },
                    { title: globalSettings?.labels?.price?.[languageObj?.id], className: 'text-right', orderData: false, width: '20%', },
                    { title: `${globalSettings?.labels?.taxAbbreviated?.[languageObj?.id]} %`, className: 'text-right', orderData: false, width: '10%', },
                    { title: globalSettings?.labels?.subTotal?.[languageObj?.id], className: 'text-right', orderable: false, width: '15%', },
                    { title: globalSettings?.labels?.process?.[languageObj?.id], className: 'text-center', orderable: false, searchable: false, width: '5%', },
                ],
                //data: purchaseDetailsTwo,
                data: [],
                destroy: true,
                info: false,
                language: dataTableLanguaje({ languageId: languageObj?.id, subMethod: currentMethod, }),
                order: [[0, 'asc'],],
                responsive: true,
                lengthChange: true,
                ordering: true,
                paging: false,
                searching: false,
                //}).buttons().container().appendTo(`#${dtPurchaseDetailsId}_wrapper .col-md-6:eq(0)`);
            });
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const purchaseDetailAddGetAsync = async ({ e = {}, rowIndex = 0, processType = 0, subMethod = '' }) => {
        const currentMethod = 'purchaseDetailAddGetAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            controlsStatusSet({ processType: 3, subMethod: currentMethod, });

            //#region concepts get
            setConcepts([]);

            response = await purchaseExpenseConceptsGetAsync({
                buildingId: purchase?.buildingId,
                isConceptsDt: true,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            setConcepts(response?.result);
            //#endregion concepts get

            //#region methods
            setProcessType(processType);
            setDtPurchaseDetailsRowIndex(rowIndex);

            setPurchaseDetailShowModal(true);
            //#endregion methods

            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }
    //#endregion methods (purchase details)

    //#region concepts (methods)
    const conceptsEditDetailsGetAsync = async ({ id = '', description = '', rowIndex = 0, processType = 0, subMethod = '', }) => {
        const currentMethod = 'conceptsEditDetailsGetAsync';
        let response = responseGet();
        try {
            setPurchaseDetailEditDelete({
                expenseConceptId: id,
                description: description,
                rowIndex: rowIndex,
                processType: processType,
                subMethod: currentMethod,
            });

            setProcessType(processType);
            setDtPurchaseDetailsRowIndex(rowIndex);

            $(`#${controls?.dataTables?.purchaseDetails?.buttons?.detailEdit?.id}`)?.trigger('click');
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const conceptsEditDetailsPosAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'conceptsEditDetailsPosAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            setShowLoading({ building: false, purchase: false, purchaseDetail: true, });

            //#region taxes get
            setTaxes([]);

            response = await purchaseTaxesGetAsync({
                buildingId: purchase?.buildingId,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ building: false, purchase: false, purchaseDetail: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            setTaxes(response?.result || []);
            //#endregion taxes get

            //#region purchase detail get
            let purchaseDetailLocal = purchaseDetails?.find(({ expenseConceptId }) => expenseConceptId === purchaseDetailEditDelete?.expenseConceptId);
            if (isUndNullEmp({ data: purchaseDetailLocal, subMethod: currentMethod, })?.result) {
                purchaseDetailLocal = purchaseDetails?.find(({ id }) => id === purchaseDetailEditDelete?.expenseConceptId);
            }
            if (isUndNullEmp({ data: purchaseDetailLocal, subMethod: currentMethod, })?.result) {
                setShowLoading({ building: false, purchase: false, purchaseDetail: false, });
                response.msgText = `${globalSettings?.labels?.expenseConcept?.[languageObj?.id]}: <b>${purchaseDetailEditDelete?.description}</b><br/>`;
                response.msgText += `${globalSettings?.messages?.cannotBeLocated?.[languageObj?.id]}<br/>`;
                response.msgText += `${globalSettings?.messages?.pleaseTryAgain?.[languageObj?.id]}`;
                await sendMessageCloseCurrentWindowAsync({
                    msgType: 1,
                    msgText: response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            setPurchaseDetail(purchaseDetailLocal);

            //#endregion purchase detail get

            setPurchaseDetailEditShowModal(true);
            setProcessType(purchaseDetailEditDelete?.processType);
            setShowLoading({ building: false, purchase: false, purchaseDetail: false, });
        } catch (ex) {
            setShowLoading({ building: false, purchase: false, purchaseDetail: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const conceptDeleteGetAsync = async ({ id = '', description = '', rowIndex = 0, subMethod = '', }) => {
        const currentMethod = 'conceptDeleteGetAsync';
        let response = responseGet();
        try {
            //#region data set
            setPurchaseDetailEditDelete({
                expenseConceptId: id,
                description: description,
                rowIndex: rowIndex,
                processType: -1,
                subMethod: currentMethod,
            });
            $(`#${controls?.dataTables?.purchaseDetails?.buttons?.detailDelete?.id}`)?.trigger('click');
            //#endregion data set
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const conceptDeletePostAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'conceptDeletePostAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            //#region variables
            let expenseConceptFind = purchaseDetailModelGet({});
            let purchaseDetailsAfter = [purchaseDetailModelGet({})];
            //#endregion variables

            //#region show message
            let msgTextObj = {
                one: `${globalSettings?.labels?.concept?.[languageObj?.id]}: <b>${purchaseDetailEditDelete?.description}</b><br/>`,
                two: `${globalSettings?.messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`,
            };

            let swalProperties = {
                icon: globalSettings?.react?.sweetAlert2?.icons?.warning,
                title: globalSettings?.messages?.areYouSureDeleteThis?.[languageObj?.id],
                html: `${msgTextObj?.one}${msgTextObj?.two}`,
                timer: null,
                backdrop: true,
                confirmButtonColor: globalSettings?.colors?.warningColorExp,
                confirmButtonText: globalSettings?.labels?.yes?.[languageObj?.id],
                showCancelButton: true, //!Swal.isLoading(), //true,
                cancelButtonColor: globalSettings?.colors?.successColorExp,
                cancelButtonText: globalSettings?.labels?.no?.[languageObj?.id],
                showLoaderOnConfirm: true,
                didOpen: () => {
                    Swal.hideLoading();
                },
                preConfirm: async () => {
                    try {
                        Swal.getCancelButton().hidden = true;
                        Swal?.update({
                            icon: globalSettings?.react?.sweetAlert2?.icons?.info,
                            title: `${globalSettings?.messages?.processing?.[languageObj?.id]}...`,
                            html: `${msgTextObj?.one}`,
                            showConfirmButton: false,
                        });

                        //#region expenseConcept delete
                        expenseConceptFind = purchaseDetails?.find(({ expenseConceptId }) => expenseConceptId === purchaseDetailEditDelete?.expenseConceptId);
                        if (!isUndNullEmp({ data: expenseConceptFind, subMethod: currentMethod, })?.result) {
                            purchaseDetailsAfter = purchaseDetails?.filter(({ expenseConceptId }) => expenseConceptId !== purchaseDetailEditDelete?.expenseConceptId) || [];
                        } else {
                            purchaseDetailsAfter = purchaseDetails?.filter(({ id }) => id !== purchaseDetailEditDelete?.expenseConceptId) || [];
                        }

                        response = purchaseDetailsCalculate({
                            neutralValue: neutralValue,
                            purchaseDetails: purchaseDetailsAfter,
                            purchase: purchase,
                            setPurchase: setPurchase,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });

                        if (!response?.isSuccess || response?.isWarning) {
                            await sendMessageCloseCurrentWindowAsync({
                                msgType: response?.msgType,
                                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                                closeWindow: false,
                                urlGoTo: response?.urlGoTo,
                                auth: auth,
                                isLogout: false,
                                languageId: languageObj?.id,
                                subMethod: currentMethod,
                            });
                            return;
                        }

                        setPurchaseDetails(purchaseDetailsAfter);
                        //#endregion expenseConcept delete

                        //#region dtExpenseConcept update
                        $(`#${dtPurchaseDetailsId}`)?.DataTable()?.row(purchaseDetailEditDelete?.rowIndex)?.remove()?.draw(true);
                        //#endregion dtExpenseConcept update

                        await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });

                        //#region old code
                        // await sendMessageCloseCurrentWindowAsync({
                        //     msgType: 0,
                        //     msgText: `${globalSettings?.messages?.processesCompletedSuccessfully?.[languageObj?.id]}.`,
                        //     closeWindow: false,
                        //     urlGoTo: response?.urlGoTo,
                        //     auth: auth,
                        //     isLogout: false,
                        //     languageId: languageObj?.id,
                        //     subMethod: currentMethod,
                        // });
                        //#endregion old code
                    } catch (ex) {
                        //#region Error
                        response.isSuccess = false;
                        response.msgType = -1;
                        response.msgText = `Method: ${currentMethod}<br/>`;
                        response.msgText += `Error: ${ex?.message}`;
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                        });
                        //#endregion Error
                    }
                },
                allowOutsideClick: () => !Swal.isLoading(),
            };

            await Swal.fire(swalProperties);
            //#endregion show message
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }
    //#endregion concepts (methods)

    //#region attachment files (methods)
    const attachmentFilesAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'attachmentFilesAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            controlsStatusSet({ processType: 2, subMethod: currentMethod, });
            await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });

            setFilesShowModal(true);
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }
    //#endregion attachment files (methods)

    //#region methods (others)
    const dataGetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'dataGetAsync';
        let response = responseGet();
        try {
            //#region variables
            let dtRows = [];
            let isEditableLocal = false;
            //let purchaseTwo = purchaseModelGet({});
            let purchaseDetailsLocal = [purchaseDetailModelGet({})];
            let purchaseDetailsThreeLocal = [purchaseDetailModelGet({})];
            //#endregion variables

            //#region initialize
            purchaseTwo = {};
            setShowView(false);
            setPurchase({});
            setBuilding({});
            setSuppliers([]);
            setPurchaseDetails([]);
            setBtnAttachmentDisabled(false);
            setPurchaseDetailsBeforeEdited([]);
            //#endregion initialize

            setShowLoading({ building: true, purchase: true, purchaseDetail: true, });

            //#region dataTable set
            response = await dataTablesSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ building: false, purchase: false, purchaseDetail: false, });
                return
            }
            //#endregion dataTable set

            //#region data get
            //#region purchase get
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                    languageId: languageObj?.id,
                },
                url: `${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlPurchases}/${id}`,
            };

            result = await axios?.get(
                headerObj?.url,
                headerObj,
            );

            response = result?.data;

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ building: false, purchase: false, purchaseDetail: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            purchaseTwo = response?.result?.purchase || {};
            //purchaseTwo = purchaseTwo;
            setPurchase(purchaseTwo);
            //#region building get
            setBuilding(response?.result?.building);
            //#endregion building get
            //#region suppliers get
            setSuppliers(response?.result?.suppliers);
            //#endregion suppliers get
            purchaseDetailsLocal = response?.result?.details || [];

            isEditableLocal = (purchaseTwo?.balance === purchaseTwo?.total) && purchaseTwo?.status === 1;
            //#endregion purchase get

            //#region concepts get
            //localConcepts = response.result.expenseConcepts;
            //#endregion concepts get

            //#region purchase get (details)
            if (!isUndNullEmp({ data: purchaseDetailsLocal, subMethod: currentMethod, })?.result && purchaseDetailsLocal?.length > 0) {
                purchaseDetailsThreeLocal = [];
                purchaseDetailsLocal?.forEach((detail) => {
                    //#region variables
                    const dtPurchaseDetailObj = {
                        description: detail?.expenseConcept?.description,
                        quantity: separatorsNumbersSet({
                            number: detail?.quantity,
                            withDecimals: true,
                            consoleLogErrorShow: true,
                            subMethod: currentMethod,
                        })?.result,
                        price: separatorsNumbersSet({
                            number: detail?.price,
                            withDecimals: true,
                            consoleLogErrorShow: true,
                            subMethod: currentMethod,
                        })?.result,
                        taxPercentage: separatorsNumbersSet({
                            number: detail?.taxPercentage,
                            withDecimals: true,
                            consoleLogErrorShow: true,
                            subMethod: currentMethod,
                        })?.result,
                        subTotal: separatorsNumbersSet({
                            number: numberSet({
                                number: (numberSet({
                                    number: detail?.quantity,
                                    type: 'd',
                                    languageId: languageObj?.id,
                                    subMethod: currentMethod,
                                })?.result * numberSet({
                                    number: detail?.price,
                                    type: 'd',
                                    languageId: languageObj?.id,
                                    subMethod: currentMethod,
                                })?.result),
                                type: 'd',
                                languageId: languageObj?.id,
                                subMethod: currentMethod,
                            })?.result,
                            withDecimals: true,
                            consoleLogErrorShow: true,
                            subMethod: currentMethod,
                        })?.result,
                    };
                    //#endregion variables
                    //#region methods
                    //subTotalLocal = numberSet((numberSet(detail?.quantity, 'd').result * numberSet(detail?.price, 'd').result), 'd');
                    dtRows?.push([
                        //detail?.expenseConcept.description,
                        dtPurchaseDetailObj?.description,
                        //separatorsNumbersSet(detail?.quantity).result,
                        dtPurchaseDetailObj?.quantity,
                        //separatorsNumbersSet(detail?.price).result,
                        dtPurchaseDetailObj?.price,
                        //separatorsNumbersSet(detail?.taxPercentage).result,
                        dtPurchaseDetailObj?.taxPercentage,
                        //separatorsNumbersSet(subTotalLocal).result,
                        dtPurchaseDetailObj?.subTotal,
                        buttonProcessGet({
                            id: detail?.id,
                            //description: detail?.expenseConcept.description,
                            description: dtPurchaseDetailObj?.description,
                            showDetails: true,
                            labelDetails: globalSettings?.labels?.detail?.[languageObj?.id],
                            enabledDetails: true,
                            showEdit: true,
                            labelEdit: globalSettings?.labels?.edit?.[languageObj?.id],
                            enabledEdit: isEditableLocal && isEditableLocal && (processEvaluateGet({
                                object: detail,
                                property: globalSettings?.labels?.process?.en?.toLowerCase(),
                                process: globalSettings?.labels?.edit?.en?.toLowerCase(),
                                subMethod: currentMethod
                            })?.result),
                            showDelete: true,
                            labelDelete: globalSettings?.labels?.delete?.[languageObj?.id],
                            enabledDelete: isEditableLocal && (processEvaluateGet({
                                object: detail,
                                property: globalSettings?.labels?.process?.en?.toLowerCase(),
                                process: globalSettings?.labels?.delete?.en?.toLowerCase(),
                                subMethod: currentMethod,
                            })?.result),
                            processButtons: [],
                        })?.result,
                    ]);

                    purchaseDetailsThreeLocal?.push({
                        id: detail?.id,
                        buildingId: detail?.buildingId || purchaseTwo?.buildingId,
                        //description: detail?.expenseConcept?.description,
                        description: dtPurchaseDetailObj?.description,
                        expenseConceptId: detail?.expenseConceptId,
                        price: detail?.price,
                        purchaseId: detail?.purchaseId,
                        quantity: detail?.quantity,
                        remark: detail?.remark,
                        taxId: detail?.taxId,
                        taxPercentage: detail?.taxPercentage,
                    });
                    //#endregion methods
                });
                setPurchaseDetails(purchaseDetailsThreeLocal);
                setPurchaseDetailsBeforeEdited(purchaseDetailsThreeLocal);
            }
            //#endregion purchase get (details)
            //#endregion data get

            //#region check if editable or not
            //setShowView(true);
            setShowView(isEditableLocal);
            //#endregion check if editable or not

            //#region dateTime in control set
            response = await dateInControlSetAsync({
                date: new Date(),
                purchaseDate:
                    purchaseTwo?.date,
                subMethod: currentMethod,
            });
            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ building: false, purchase: false, purchaseDetail: false, });
                return;
            }
            //#endregion dateTime in control set

            //#region data in dataTable set
            $(`#${dtPurchaseDetailsId}`)?.DataTable()?.rows?.add(dtRows)?.draw(true);
            //#endregion data in dataTable set

            setShowLoading({ building: false, purchase: false, purchaseDetail: false, });
        } catch (ex) {
            setShowLoading({ building: false, purchase: false, purchaseDetail: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const dateInControlSetAsync = async ({ date = new Date(), purchaseDate = {}, subMethod = '', }) => {
        const currentMethod = 'dateInControlSetAsync';
        let response = responseGet();
        try {
            //#region variables
            const dateTimeObj = {
                date: '',
                time: 0,
                format: languageObj?.format?.date?.f1,
                formatTwo: languageObj?.format?.date?.f11,
            };
            //#endregion variables

            //#region methods
            if (!isUndNullEmp({ data: purchaseDate, subMethod: currentMethod, })?.result) {
                dateTimeObj.date = dateTimeFormatGlobalSet({
                    date: purchaseDate,
                    type: dateTimeObj?.format,
                    format: 0,
                    addTime: false,
                    secondsShow: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;
            } else if (!isUndNullEmp({ data: date, subMethod: currentMethod, })?.result) {
                dateTimeObj.date = dateTimeFormatGlobalSet({
                    date: date,
                    type: dateTimeObj?.format,
                    format: 0,
                    addTime: false,
                    secondsShow: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;
            }

            $.fn.datetimepicker.Constructor.Default = $.extend({}, $.fn.datetimepicker.Constructor.Default, {
                icons: globalSettings?.react?.tempusDominus?.icons,
                buttons: globalSettings?.react?.tempusDominus?.buttons,
                tooltips: globalSettings?.react?.tempusDominus?.tooltips,
                locale: languageObj?.id,
            });

            $(`#${purchaseDateId}`)?.datetimepicker({
                default: false,
                'date': moment(dateTimeObj?.date, dateTimeObj?.formatTwo),
                format: dateTimeObj?.formatTwo,
            });
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const dataTablesSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'dataTablesSetAsync';
        let response = responseGet();
        try {
            //#region dataTables set
            response = await dataTablePurchaseDetailsSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }
            //#endregion dataTables set

            //#region query set
            response = await queryCodeSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }
            //#endregion query set
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const errorsDefaultSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'errorsDefaultSetAsync';
        let response = responseGet();
        try {
            setDateError('');
            setNumberError('');
            setSupplierError('');
            setPurchaseNumberError('');
            setPurchaseDescriptionError('');
            setPurchaseControlNumberError('');
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const formDataValidateAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'formDataValidateAsync';
        let response = responseGet();
        try {
            //#region method
            response = await purchaseFormDataValidateAsync({
                purchase: purchase,
                purchaseDetails: purchaseDetails,
                dtPurchaseDetailsId: dtPurchaseDetailsId,
                purchaseDateInputId: controls?.inputs?.date?.id,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess) {
                return response;
            }

            if (response?.isWarning) {
                setNumberError(response?.result?.numberErrorSet);
                setDateError(response?.result?.dateErrorSet);
                setSupplierError(response?.result?.supplierErrorSet);
                setPurchaseNumberError(response?.result?.purchaseNumberErrorSet);
                setPurchaseControlNumberError(response?.result?.purchaseControlNumberErrorSet);
                setPurchaseDescriptionError(response?.result?.purchaseDescriptionErrorSet);
                if (!isUndNullEmp({ data: response?.msgText, subMethod: currentMethod })?.result ||
                    !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod })?.result) {
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: response?.msgType,
                        msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                        closeWindow: false,
                        urlGoTo: response?.urlGoTo,
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                }
            }
            //#endregion method
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const queryCodeSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'queryCodeSetAsync';
        let response = responseGet();
        try {
            //#region variables
            let id = '';
            let method = '';
            let rowIndex = 0;
            let dtRowIndex = 0;
            let description = '';
            //#endregion variables

            //#region methods
            $(`#${dtPurchaseDetailsId} tbody`)?.on('click', 'tr', 'td', function (e) {
                e?.preventDefault();
                rowIndex = $(`#${dtPurchaseDetailsId}`)?.DataTable()?.row(this)?.index();
                dtRowIndex = !isUndNullEmp({ data: rowIndex, subMethod: currentMethod, })?.result ? rowIndex : dtRowIndex;
                if (!isUndNullEmp({ data: dtRowIndex, subMethod: currentMethod, })?.result) {
                    id = e?.target?.attributes?.id?.value || '';
                    method = e?.target?.attributes?.method?.value || '';
                    description = e?.target?.attributes?.description?.value || '';
                    switch (method) {
                        case 'edit':
                            conceptsEditDetailsGetAsync({ id: id, description: description, rowIndex: dtRowIndex, processType: 1, subMethod: currentMethod, });
                            break;
                        case 'details':
                            conceptsEditDetailsGetAsync({ id: id, description: description, rowIndex: dtRowIndex, processType: 2, subMethod: currentMethod, });
                            break;
                        case 'delete':
                            conceptDeleteGetAsync({ id: id, description: description, rowIndex: dtRowIndex, subMethod: currentMethod, });
                            break;
                        default:
                            break;
                    }
                }
            });
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const goToBackAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'goToBackAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            controlsStatusSet({ processType: 4, subMethod: currentMethod, });
            response = await errorsDefaultSetAsync({ subMethod: currentMethod });
            await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });
            window.location.href = globalSettings?.app?.backend?.urlPurchases;
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const controlsStatusSet = ({ processType = 0, subMethod = '', }) => {
        let response = responseGet();
        const currentMethod = 'controlsStatusSet';
        try {
            //#region variables
            //#endregion variables

            //#region methods
            switch (processType) {
                case 0:
                    $(`#${controls?.dataTables?.purchaseDetails?.icons?.detailAdd?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.purchaseDetails?.buttons?.detailAdd?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.purchaseDetails?.spinners?.detailAdd?.id}`)?.removeClass();

                    $(`#${controls?.dataTables?.purchaseDetails?.icons?.detailAdd?.id}`)?.addClass(controls?.dataTables?.purchaseDetails?.icons?.detailAdd?.className);
                    $(`#${controls?.dataTables?.purchaseDetails?.buttons?.detailAdd?.id}`)?.addClass(controls?.dataTables?.purchaseDetails?.buttons?.detailAdd?.className);
                    $(`#${controls?.dataTables?.purchaseDetails?.spinners?.detailAdd?.id}`)?.addClass(controls?.dataTables?.purchaseDetails?.spinners?.detailAdd?.className);

                    for (let ctrStr in controls) {
                        const objStr = ['buttons', 'spinners', 'icons'];
                        if (objStr?.includes(ctrStr)) {
                            for (let propStr in controls?.[ctrStr]) {
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.removeClass();
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.addClass(controls?.[ctrStr]?.[propStr]?.className);
                            }
                        }
                    }
                    break;
                case 1:
                    //$(`#${controls?.buttons?.create?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled} ${settings.react.html.button.classes.progress}`);
                    $(`#${controls?.icons?.save?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.save?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                case 2:
                    $(`#${controls?.icons?.attachment?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.attachment?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                case 3:
                    $(`#${controls?.dataTables?.purchaseDetails?.icons?.detailAdd?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.purchaseDetails?.spinners?.detailAdd?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                case 4:
                    $(`#${controls?.icons?.back?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.back?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                default:
                    break;
            }

            //#region controls
            $(`#${controls?.inputs?.purchaseNumber?.id}`).attr('readOnly', (processType !== 0));
            $(`#${controls?.inputs?.date?.id}`).attr('readOnly', (processType !== 0));
            $(`#${controls?.selects?.suppliers?.id}`).attr('disabled', (processType !== 0));
            $(`#${controls?.inputs?.purchaseNumberSupplier?.id}`).attr('readOnly', (processType !== 0));
            $(`#${controls?.inputs?.purchaseControlNumberSupplier?.id}`).attr('readOnly', (processType !== 0));
            $(`#${controls?.inputs?.remark?.id}`).attr('readOnly', (processType !== 0));
            //#endregion controls

            //#region url (register / passwords)
            // $(`#${controls?.urls?.forgotYourPassword?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlForgotPassword));
            // $(`#${controls?.urls?.userRegister?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlUserRegister));
            // $(`#${controls?.urls?.registerStatus?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlRegisterStatus));
            //#endregion url (register / passwords)

            //#region url (rechaptcha)
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.react?.reCAPTCHA?.urlPrivaciConditions));
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('target', (processType !== 0 ? '' : '_blank'));
            //#endregion url (rechaptcha)

            //#region urls
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr({
            //     'href': (processType !== 0 ? urlStop : globalSettings?.app?.reCAPTCHA?.urlPrivaciConditions),
            //     'target': (processType !== 0 ? '' : '_blank'),
            // });
            //#endregion urls

            //#region dataTable buttons
            // btnExcel.node.disabled = processType !== 0;
            // btnPdf.node.disabled = processType !== 0;
            //#endregion dataTable buttons

            $(`#${controls?.dataTables?.purchaseDetails?.inputs?.search?.id}`)?.attr('readOnly', (processType !== 0));
            $(`#${controls?.dataTables?.purchaseDetails?.selects?.entries?.id}`)?.attr('disabled', (processType !== 0));

            if (processType !== 0) {
                $(`#${controls?.buttons?.save?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled}`);
                $(`#${controls?.buttons?.attachment?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled}`);
                $(`#${controls?.buttons?.back?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled}`);
                $(`#${controls?.dataTables?.purchaseDetails?.buttons?.detailAdd?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled}`);
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console?.error(response);
        }
        return response;
    }

    useEffect(() => {
        dataGetAsync({ subMethod: 'form - onLoad', });
    }, []) //eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods (others)

    return (
        <div>
            <Menu viewName='expenses' process='purchases' />

            <div className='content-wrapper'>

                {/* Content Header (Page header) */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2'>
                            <div className='col-sm-6'>
                                <h6 className='m-0'>{globalSettings?.labels?.purchases?.[languageObj?.id]}</h6>
                            </div>{/* /.col */}
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right'>
                                    <li className='breadcrumb-item'><Link to='/'>{globalSettings?.labels?.home?.[languageObj?.id]}</Link></li>
                                    <li className='breadcrumb-item'><Link to={globalSettings?.app?.backend?.urlPurchases}>{globalSettings?.labels?.purchases?.[languageObj?.id]}</Link></li>
                                    <li className='breadcrumb-item active'>{globalSettings?.labels?.edit?.[languageObj?.id]}</li>
                                </ol>
                            </div>{/* /.col */}
                        </div>{/* /.row */}
                    </div>{/* /.container-fluid */}
                </div>
                {/* /.content-header */}

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>

                        {/*buildings*/}
                        <BuildingHeader buildingsId={''}
                            building={building}
                            buildings={[]}
                            btnSyncDisabled={''}
                            methodGetAsync={null}
                            processType={1}
                            headerSectionValues={{}}
                            showLoading={showLoading?.building}
                            languageObj={languageObj} />

                        {/*purchase*/}
                        <div className='row'>
                            <div className='col-12'>
                                <form onSubmit={(e) => purchaseEditPostAsync({ e: e, subMethod: 'form - onSubmit', })}>
                                    <div className='card card-outline card-primary shadow' >
                                        <LoadingSection alt='loadingSection'
                                            className={globalSettings?.react?.html?.overlay?.darkTextWhite}
                                            showText={true}
                                            text={globalSettings?.messages?.processing?.[languageObj?.id]}
                                            height={25}
                                            hidden={!showLoading?.purchase}
                                            width={25}
                                            languageId={languageObj?.id}
                                            subMethod={currentMethod} />

                                        <div className='card-header'>
                                            <h6 className='card-title'>
                                                <img alt={globalSettings?.labels?.purchase?.[languageObj?.id]}
                                                    src={globalSettings?.images?.invoiceLogo}
                                                    style={styles?.cardHeaderLogo}>
                                                </img> - {globalSettings?.labels?.purchase?.[languageObj?.id]} ({globalSettings?.labels?.edit?.[languageObj?.id]?.toLowerCase()})
                                            </h6>
                                            <div className='card-tools'>
                                                <button type='button' className='btn btn-tool' data-card-widget='collapse'>
                                                    <i className={globalSettings?.icons?.minus}></i>
                                                </button>
                                            </div>
                                        </div>

                                        <div className='card-body'>

                                            {/* <div className='row'><div className='col-md-6'></div><div className='col-md-6'></div></div><hr /> */}

                                            <div className='row'>
                                                <div className='col-md-4'>
                                                    <div className='form-group'>
                                                        <div className='input-group mb-3'>
                                                            <input id={controls?.inputs?.purchaseNumber?.id}
                                                                className={controls?.inputs?.purchaseNumber?.className}
                                                                //autoFocus
                                                                maxLength={globalSettings?.documentNumberLength?.purchase}
                                                                onChange={(e) => setPurchase({
                                                                    ...purchase,
                                                                    number: numberSet({
                                                                        number: e?.target?.value,
                                                                        type: 'i',
                                                                        languageId: languageObj?.id,
                                                                        subMethod: 'input - purchaseNumber',
                                                                    })?.result,
                                                                })}
                                                                onFocus={() => setNumberError('')}
                                                                placeholder={globalSettings?.labels?.number?.[languageObj?.id]}
                                                                disabled={!showView}
                                                                tooltip='tooltip'
                                                                title={globalSettings?.labels?.number?.[languageObj?.id]}
                                                                value={purchase?.number || 0} />
                                                            <div className='input-group-append'>
                                                                <div className='input-group-text'>
                                                                    <span className={globalSettings?.icons?.sortNumericUpAlt} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(numberError)}</div>
                                                    </div>
                                                </div>
                                                <div className='col-md-4'>
                                                    <div className='form-group text-center'>
                                                        {
                                                            purchaseStatusGet({
                                                                purchase: purchase || purchaseModelGet({}),
                                                                showStateLabel: true,
                                                                htmlParser: true,
                                                                languageId: languageObj?.id,
                                                                subMethod: 'lbl - purchaseStatus',
                                                            })?.result
                                                        }
                                                    </div>
                                                </div>
                                                <div className='col-md-4'>
                                                    <div className='form-group'>
                                                        <div className='input-group mb-3'>
                                                            <div className='input-group date'
                                                                id={purchaseDateId} data-target-input='nearest'>
                                                                <input id={controls?.inputs?.date?.id}
                                                                    className={controls?.inputs?.date?.className}
                                                                    data-target={`#${purchaseDateId}`}
                                                                    data-toggle='datetimepicker'
                                                                    onFocus={() => setDateError('')}
                                                                    placeholder={globalSettings?.labels?.date?.[languageObj?.id]}
                                                                    disabled={!showView}
                                                                    tooltip='tooltip'
                                                                    title={globalSettings?.labels?.date?.[languageObj?.id]}
                                                                    type='text' />
                                                                <div className='input-group-append' data-target={`#${purchaseDateId}`} data-toggle='datetimepicker'>
                                                                    <div className='input-group-text'><i className={globalSettings?.icons?.calendarAlt}></i></div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(dateError)}</div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='row'>
                                                <div className='col-md-8'>
                                                    <div className='form-group'>
                                                        <div className='input-group mb-3'>
                                                            <select id={controls?.selects?.suppliers?.id}
                                                                className={controls?.selects?.suppliers?.className}
                                                                onChange={(e) => setPurchase({ ...purchase, supplierId: e?.target?.value, })}
                                                                onFocus={() => setSupplierError('')}
                                                                placeholder={globalSettings?.labels?.supplier?.[languageObj?.id]}
                                                                disabled={!showView}
                                                                tooltip='tooltip'
                                                                title={globalSettings?.labels?.supplier?.[languageObj?.id]}
                                                                value={purchase?.supplierId || ''} >
                                                                <option key='nothing' value=''>{globalSettings?.labels?.selectSupplier?.[languageObj?.id]}</option>
                                                                {suppliers?.map((supplier = supplierModelGet({})) => <option key={supplier?.id} value={supplier?.id}>{supplier?.description}</option>)}
                                                            </select>
                                                            <div className='input-group-append'>
                                                                <div className='input-group-text'>
                                                                    <span className='fas fa-user-tie' />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(supplierError)}</div>
                                                    </div>
                                                </div>
                                                <div className='col-md-4'>
                                                    <div className='form-group text-muted'>
                                                        <div className='input-group'>
                                                            <div className={controls?.checkBox?.isNational?.className}>
                                                                <input id={controls?.checkBox?.isNational?.id}
                                                                    checked={suppliers?.find(({ id }) => id === purchase?.supplierId)?.national || false}
                                                                    //onChange={(e) => setPurchase({...purchase, national: e.target.checked,})}
                                                                    readOnly
                                                                    tooltip='tooltip'
                                                                    title={globalSettings?.labels?.isNational?.[languageObj?.id]}
                                                                    type='checkbox' />
                                                                <label htmlFor={controls?.checkBox?.isNational?.id}
                                                                    tooltip='tooltip'
                                                                    title={globalSettings?.labels?.isNational?.[languageObj?.id]}>{globalSettings?.labels?.isNational?.[languageObj?.id]}?
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='row'>
                                                <div className='col-md-4'>
                                                    <div className='form-group'>
                                                        <div className='input-group mb-3'>
                                                            <input id={controls?.inputs?.purchaseNumberSupplier?.id}
                                                                className={controls?.inputs?.purchaseNumberSupplier?.className}
                                                                maxLength={globalSettings?.documentNumberLength?.invoice}
                                                                onChange={(e) => setPurchase({ ...purchase, invoiceNumber: e?.target?.value, })}
                                                                onFocus={() => setPurchaseNumberError('')}
                                                                placeholder={globalSettings?.labels?.invoiceNumber?.[languageObj?.id]}
                                                                disabled={!showView}
                                                                tooltip='tooltip'
                                                                title={globalSettings?.labels?.invoiceNumber?.[languageObj?.id]}
                                                                value={purchase?.invoiceNumber || ''} />
                                                            <div className='input-group-append'>
                                                                <div className='input-group-text'>
                                                                    <span className='fas fa-file-invoice-dollar' />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(purchaseNumberError)}</div>
                                                    </div>
                                                </div>
                                                <div className='col-md-4'>

                                                </div>
                                                <div className='col-md-4'>
                                                    <div className='form-group'>
                                                        <div className='input-group mb-3'>
                                                            <input id={controls?.inputs?.purchaseControlNumberSupplier?.id}
                                                                className={controls?.inputs?.purchaseControlNumberSupplier?.className}
                                                                maxLength={globalSettings?.documentNumberLength?.invoice}
                                                                onChange={(e) => setPurchase({ ...purchase, invoiceControlNumber: e?.target?.value, })}
                                                                onFocus={() => setPurchaseControlNumberError('')}
                                                                placeholder={globalSettings?.labels?.controlNumber?.[languageObj?.id]}
                                                                disabled={!showView}
                                                                tooltip='tooltip'
                                                                title={globalSettings?.labels?.controlNumber?.[languageObj?.id]}
                                                                value={purchase?.invoiceControlNumber || ''} />
                                                            <div className='input-group-append'>
                                                                <div className='input-group-text'>
                                                                    <span className='fas fa-file-signature' />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(purchaseControlNumberError)}</div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='row'>
                                                <div className='col-md-12'>
                                                    <div className='form-group'>
                                                        <div className='input-group mb-3'>
                                                            <textarea id={controls?.inputs?.remark?.id}
                                                                className={controls?.inputs?.remark?.className}
                                                                onChange={(e) => setPurchase({ ...purchase, description: e?.target?.value, })}
                                                                onFocus={() => setPurchaseDescriptionError('')}
                                                                placeholder={globalSettings?.labels?.remark?.[languageObj?.id]}
                                                                disabled={!showView}
                                                                rows={2}
                                                                tooltip='tooltip'
                                                                title={globalSettings?.labels?.remark?.[languageObj?.id]}
                                                                value={purchase?.description || ''}>
                                                            </textarea>
                                                            <div className='input-group-append'>
                                                                <div className='input-group-text'>
                                                                    <span className={globalSettings?.icons?.spellCheck} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(purchaseDescriptionError)}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className='card-footer'>
                                            <div className='form-group text-right'>
                                                <button id={controls?.buttons?.save?.id}
                                                    className={controls?.buttons?.save?.className}
                                                    disabled={!showView}
                                                    hidden={!showView}
                                                    tooltip='tooltip'
                                                    title={globalSettings?.labels?.save?.[languageObj?.id]}
                                                    type='submit'>
                                                    <i id={controls?.icons?.save?.id} className={controls?.icons?.save?.className} /> <span id={controls?.spinners?.save?.id} className='' aria-hidden='true'></span>
                                                </button>
                                                <button id={controls?.buttons?.attachment?.id}
                                                    className={controls?.buttons?.attachment?.className}
                                                    disabled={btnAttachmentDisabled}
                                                    onClick={(e) => attachmentFilesAsync({ e: e, subMethod: 'btn - attachmentFile', })}
                                                    tooltip='tooltip'
                                                    title={globalSettings?.labels?.toAttach?.[languageObj?.id]}
                                                    type='button'>
                                                    <i id={controls?.icons?.attachment?.id} className={controls?.icons?.attachment?.className} /> <span id={controls?.spinners?.attachment?.id} className='' aria-hidden='true'></span>
                                                </button>
                                                <button id={controls?.buttons?.back?.id}
                                                    className={controls?.buttons?.back?.className}
                                                    onClick={(e) => goToBackAsync({ e: e, subMethod: 'btn - back', })}
                                                    tooltip='tooltip'
                                                    title={globalSettings?.labels?.back?.[languageObj?.id]}
                                                    type='button'>
                                                    <i id={controls?.icons?.back?.id} className={controls?.icons?.back?.className} /> <span id={controls?.spinners?.back?.id} className='' aria-hidden='true'></span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>

                        {/*purchase (details)*/}
                        <div className='row'>
                            <div className='col-12'>
                                <div className='card card-outline card-primary shadow' >
                                    <LoadingSection alt='loadingSection'
                                        className={globalSettings?.react?.html?.overlay?.darkTextWhite}
                                        showText={true}
                                        text={globalSettings?.messages?.processing?.[languageObj?.id]}
                                        height={25}
                                        hidden={!showLoading?.purchaseDetail}
                                        width={25}
                                        languageId={languageObj?.id}
                                        subMethod={currentMethod} />

                                    <div className='card-header'>
                                        <h6 className='card-title'>
                                            <img alt={globalSettings?.labels?.purchase?.[languageObj?.id]}
                                                src={globalSettings?.images?.shoppingCart}
                                                style={styles?.cardHeaderLogo}>
                                            </img> - {globalSettings?.labels?.purchase?.[languageObj?.id]} ({globalSettings?.labels?.detail?.[languageObj?.id]?.toLowerCase()})
                                        </h6>
                                        <div className='card-tools'>
                                            <button type='button' className='btn btn-tool' data-card-widget='collapse'>
                                                <i className={globalSettings?.icons?.minus}></i>
                                            </button>
                                        </div>
                                    </div>

                                    <div className='card-body'>
                                        <div className='row'>
                                            <div className='col-md-12 text-muted'>
                                                <button id={controls?.dataTables?.purchaseDetails?.buttons?.detailAdd?.id}
                                                    className={controls?.dataTables?.purchaseDetails?.buttons?.detailAdd?.className}
                                                    disabled={!showView}
                                                    tooltip='tooltip'
                                                    title={globalSettings?.labels?.addDetail}
                                                    type='button'
                                                    onClick={(e) => purchaseDetailAddGetAsync({ e: e, rowIndex: 0, processType: 1, subMethod: 'btn - purchaseDetailAdd', })}>
                                                    <i id={controls?.dataTables?.purchaseDetails?.icons?.detailAdd?.id} className={controls?.dataTables?.purchaseDetails?.icons?.detailAdd?.className} /> <span id={controls?.dataTables?.purchaseDetails?.spinners?.detailAdd?.id} className='' aria-hidden='true'></span>
                                                </button>
                                                <button id={controls?.dataTables?.purchaseDetails?.buttons?.detailEdit?.id}
                                                    className={controls?.dataTables?.purchaseDetails?.buttons?.detailEdit?.className}
                                                    hidden={true}
                                                    onClick={(e) => conceptsEditDetailsPosAsync({ e: e, subMethod: 'btn - purchaseDetailEdit', })}
                                                    tooltip='tooltip'
                                                    title={globalSettings?.labels?.edit?.[languageObj?.id]}
                                                    type='button'>
                                                    <i id={controls?.dataTables?.purchaseDetails?.icons?.detailEdit?.id} className={controls?.dataTables?.purchaseDetails?.icons?.detailEdit?.className} /> <span id={controls?.dataTables?.purchaseDetails?.spinners?.detailEdit?.id} className='' aria-hidden='true'></span>
                                                </button>
                                                <button id={controls?.dataTables?.purchaseDetails?.buttons?.detailDelete?.id}
                                                    className={controls?.dataTables?.purchaseDetails?.buttons?.detailDelete?.className}
                                                    disabled={!showView}
                                                    hidden={true}
                                                    onClick={(e) => conceptDeletePostAsync({ e: e, subMethod: 'btn - purchaseDetailDelete', })}
                                                    tooltip='tooltip'
                                                    title={globalSettings?.labels?.delete?.[languageObj?.id]}
                                                    type='button'>
                                                    <i id={controls?.dataTables?.purchaseDetails?.icons?.detailDelete?.id} className={controls?.dataTables?.purchaseDetails?.icons?.detailDelete?.className} /> <span id={controls?.dataTables?.purchaseDetails?.spinners?.detailDelete?.id} className='' aria-hidden='true'></span>
                                                </button>
                                            </div>
                                        </div>

                                        <div className='row'>
                                            <div className='col-md-12'>
                                                <div className={globalSettings?.html?.dataTables?.formats?.tableResponsiveSm}>
                                                    <table id={dtPurchaseDetailsId} className={globalSettings?.html?.dataTables?.formats?.smStripedBordered}></table>
                                                </div>
                                            </div>
                                        </div>

                                        {/* <div className='row'>
                                            <div className='col-md-6'>
                                            </div>
                                            <div className='col-md-6'>
                                                <div className='table-responsive'>
                                                    <table className='table table-sm'>
                                                        <tbody>
                                                            <tr>
                                                                <th style={{ width: '50%' }}>{globalSettings?.labels?.subTotal?.[languageObj?.id]}:</th>
                                                                <td className='text-right'>{separatorsNumbersSet(!isUndefined(purchase.subTotal) ? purchase.subTotal : neutralValue).result}</td>
                                                            </tr>
                                                            <tr>
                                                                <th>{globalSettings?.labels?.taxBase?.[languageObj?.id]}:</th>
                                                                <td className='text-right'>{separatorsNumbersSet(!isUndefined(purchase.taxBase) ? purchase.taxBase : neutralValue).result}</td>
                                                            </tr>
                                                            <tr>
                                                                <th>{globalSettings?.labels?.exemptAmount?.[languageObj?.id]}:</th>
                                                                <td className='text-right'>{separatorsNumbersSet(!isUndefined(purchase.exemptAmount) ? purchase.exemptAmount : neutralValue).result}</td>
                                                            </tr>
                                                            <tr>
                                                                <th>{globalSettings?.labels?.tax?.[languageObj?.id]} ({separatorsNumbersSet(!isUndefined(purchase.taxPercentage) ? purchase.taxPercentage : neutralValue).result} %):</th>
                                                                <td className='text-right'>{separatorsNumbersSet(!isUndefined(purchase.taxAmount) ? purchase.taxAmount : neutralValue).result}</td>
                                                            </tr>
                                                            <tr>
                                                                <th>{globalSettings?.labels?.total?.[languageObj?.id]}:</th>
                                                                <td className='text-right'>{separatorsNumbersSet(!isUndefined(purchase.total) ? purchase.total : neutralValue).result}</td>
                                                            </tr>
                                                            <tr>
                                                                <th>{globalSettings?.labels?.balance?.[languageObj?.id]}:</th>
                                                                <td className='text-right'>{separatorsNumbersSet(!isUndefined(purchase.balance) ? purchase.balance : neutralValue).result}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div> */}

                                        {/*resumen*/}
                                        <div className='row'>
                                            <div className='col-md-6'>
                                            </div>
                                            <div className='col-md-6'>
                                                <div className='table-responsive'>
                                                    <table className='table table-sm'>
                                                        <tbody>
                                                            <tr>
                                                                <th style={{ width: '50%' }}>{globalSettings?.labels?.subTotal?.[languageObj?.id]}:</th>
                                                                <td className='text-right'>{
                                                                    separatorsNumbersSet({
                                                                        number: purchase?.subTotal || neutralValue,
                                                                        withDecimals: true,
                                                                        consoleLogErrorShow: true,
                                                                        subMethod: 'input - purchaseSubTotal',
                                                                    })?.result
                                                                }</td>
                                                            </tr>
                                                            <tr>
                                                                <th>{globalSettings?.labels?.taxBase?.[languageObj?.id]}:</th>
                                                                <td className='text-right'>{
                                                                    separatorsNumbersSet({
                                                                        number: purchase?.taxBase || neutralValue,
                                                                        withDecimals: true,
                                                                        consoleLogErrorShow: true,
                                                                        subMethod: 'input - purchaseTaxBase',
                                                                    })?.result
                                                                }</td>
                                                            </tr>
                                                            <tr>
                                                                <th>{globalSettings?.labels?.exemptAmount?.[languageObj?.id]}:</th>
                                                                <td className='text-right'>{
                                                                    separatorsNumbersSet({
                                                                        number: purchase?.exemptAmount || neutralValue,
                                                                        withDecimals: true,
                                                                        consoleLogErrorShow: true,
                                                                        subMethod: 'input - purchaseExemptAmount',
                                                                    })?.result
                                                                }</td>
                                                            </tr>
                                                            <tr>
                                                                <th>{globalSettings?.labels?.tax?.[languageObj?.id]} ({
                                                                    separatorsNumbersSet({
                                                                        number: purchase?.taxPercentage || neutralValue,
                                                                        withDecimals: true,
                                                                        consoleLogErrorShow: true,
                                                                        subMethod: 'input - purchaseTaxPercentage',
                                                                    })?.result
                                                                } %):</th>
                                                                <td className='text-right'>{
                                                                    separatorsNumbersSet({
                                                                        number: purchase?.taxAmount || neutralValue,
                                                                        withDecimals: true,
                                                                        consoleLogErrorShow: true,
                                                                        subMethod: 'input - purchaseTaxAmount',
                                                                    })?.result
                                                                }</td>
                                                            </tr>
                                                            <tr>
                                                                <th>{globalSettings?.labels?.total?.[languageObj?.id]}:</th>
                                                                <td className='text-right'>{
                                                                    separatorsNumbersSet({
                                                                        number: purchase?.total || neutralValue,
                                                                        withDecimals: true,
                                                                        consoleLogErrorShow: true,
                                                                        subMethod: 'input - purchaseTotal',
                                                                    })?.result
                                                                }</td>
                                                            </tr>
                                                            <tr>
                                                                <th>{globalSettings?.labels?.balance?.[languageObj?.id]}:</th>
                                                                <td className='text-right'>{
                                                                    separatorsNumbersSet({
                                                                        number: purchase?.balance || neutralValue,
                                                                        withDecimals: true,
                                                                        consoleLogErrorShow: true,
                                                                        subMethod: 'input - purchaseBalance',
                                                                    })?.result
                                                                }</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='card-footer'>
                                        <div className='form-group text-right'>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </section>

            </div>

            {purchaseDetailShowModal ?
                <PurchaseConceptAdd $={$}
                    auth={auth}
                    purchase={purchase}
                    purchaseDetails={purchaseDetails}
                    setPurchaseDetails={setPurchaseDetails}
                    concepts={concepts}
                    dtId={dtPurchaseDetailsId}
                    showModal={purchaseDetailShowModal}
                    setShowModal={setPurchaseDetailShowModal}
                    processType={processType} />
                :
                <></>
            }

            {purchaseDetailEditShowModal ?
                <PurchaseConceptEdit $={$}
                    auth={auth}
                    neutralValue={neutralValue}
                    purchase={purchase}
                    setPurchase={setPurchase}
                    purchaseDetail={purchaseDetail}
                    setPurchaseDetail={setPurchaseDetail}
                    purchaseDetails={purchaseDetails}
                    setPurchaseDetails={setPurchaseDetails}
                    dtId={dtPurchaseDetailsId}
                    rowIndex={dtPurchaseDetailsRowIndex}
                    taxes={taxes}
                    showModal={purchaseDetailEditShowModal}
                    setShowModal={setPurchaseDetailEditShowModal}
                    processType={processType} />
                :
                <></>
            }

            {filesShowModal ?
                <PurchaseFiles $={$}
                    auth={auth}
                    userRole={userRole}
                    showModal={filesShowModal}
                    setShowModal={setFilesShowModal}
                    purchase={purchase}
                    setPurchase={setPurchase}
                    languageObj={languageObj} />
                :
                <></>
            }

        </div>
    )
}